
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timelapse/[id]",
      function () {
        return require("private-next-pages/timelapse/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timelapse/[id]"])
      });
    }
  